var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "profile-editor" }, [
    _c("div", { staticClass: "actions-row" }, [
      _c("div", { staticClass: "select-container" }, [
        _c("h5", [_vm._v("Products")]),
        _c(
          "button",
          {
            staticClass: "button button-add-more",
            attrs: { title: "Select multiple products" },
            on: {
              click: function ($event) {
                return _vm.openMultiProductModal()
              },
            },
          },
          [_vm._v(" Select product(s) ")]
        ),
        _c(
          "button",
          {
            staticClass: "button",
            on: {
              click: function ($event) {
                return _vm.chooseDate()
              },
            },
          },
          [_vm._v("Select Date")]
        ),
        _vm.optionsLoading
          ? _c("div", { staticClass: "labs-loader" })
          : _vm._e(),
        _c("div", { staticClass: "date-display" }, [
          _c("strong", { staticClass: "text" }, [_vm._v("Calculate as of")]),
          _c("div", { staticClass: "date" }, [
            _vm.asOf.type === "static"
              ? _c("span", [
                  _vm._v(_vm._s(_vm.asOfDate.toISOString().slice(0, 10))),
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(_vm.asOf.data.count) +
                      " " +
                      _vm._s(_vm.asOf.data.unit) +
                      _vm._s(_vm.asOf.data.count !== 1 ? "s" : "") +
                      " ago"
                  ),
                ]),
          ]),
        ]),
      ]),
    ]),
    _vm.selectedProducts.length >= 1
      ? _c("div", { staticClass: "multi-products-row" }, [
          _c(
            "div",
            {
              staticClass: "multi-products-list",
              attrs: { title: _vm.selectedProductsString },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.selectedProducts.length) +
                  " products selected "
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "pseudo-link",
              on: {
                click: function ($event) {
                  return _vm.openMultiProductModal()
                },
              },
            },
            [_vm._v(" [Edit] ")]
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "create-profile-row" }, [
      _c("div", { staticClass: "select-column" }, [
        _c("h5", [_vm._v(" Sources ")]),
        _c("div", { staticClass: "select-container" }, [
          _vm.dataSources.length
            ? _c("div", { staticClass: "select-all-items" }, [
                _c("div", [
                  _vm._v(
                    " " + _vm._s(_vm.selectedDataSources.length) + " selected "
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        return _vm.addAllDataSources()
                      },
                    },
                  },
                  [
                    _vm.selectedDataSources.length !== _vm.dataSources.length
                      ? _c("span", [_vm._v("Add")])
                      : _c("span", [_vm._v("Remove")]),
                    _vm._v(" All (" + _vm._s(_vm.dataSources.length) + ") "),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.dataSources.length
            ? _c("div", { staticClass: "select-header" }, [
                _c("span", [
                  _vm._v(" No. of Instruments "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content:
                              "For selected product type(s), the number of instruments for which any trade has been observed over the last 2 years",
                          },
                          expression:
                            "{\n              content: 'For selected product type(s), the number of instruments for which any trade has been observed over the last 2 years'\n            }",
                        },
                      ],
                      staticClass: "info-icon",
                    },
                    [
                      _c("i", { staticClass: "material-icons info-outline" }, [
                        _vm._v("info_outline"),
                      ]),
                      _c("i", { staticClass: "material-icons info" }, [
                        _vm._v("info"),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "select-scrollable" }, [
            _c(
              "div",
              {
                staticClass: "select-inner",
                class: { "select-inner--empty": !_vm.dataSources.length },
              },
              [
                !_vm.dataSources.length
                  ? _c("div", { staticClass: "select-all-empty" }, [
                      _c("span", { staticClass: "icon-layout-3" }),
                      _c("p", [
                        _vm._v(
                          " Select a Product to begin building a Profile "
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._l(_vm.dataSources, function (ds, index) {
                  return _c(
                    "div",
                    {
                      key: "ds_" + index,
                      staticClass: "select-item select-item--with-count",
                      class: {
                        "select-item--active":
                          _vm.selectedDataSources.indexOf(ds.id) > -1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleSelectedDataSourceItem(ds.id)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "select-item__left",
                          attrs: {
                            title: _vm.venuesDisplayMap[ds.id] || ds.id,
                          },
                        },
                        [
                          _c("div", { staticClass: "select-item__checkbox" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.venuesDisplayMap[ds.id] || ds.id) +
                              " "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "select-item__count" }, [
                        _vm._v(" " + _vm._s(ds.count) + " "),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "select-column" }, [
        _c("h5", { attrs: { title: "Attributes for Risk Factor Mapping" } }, [
          _vm._v(" Attributes to Group By "),
        ]),
        _c("div", { staticClass: "select-container" }, [
          _vm.attributes.length
            ? _c("div", { staticClass: "select-all-items" }, [
                _c("div", [
                  _vm._v(
                    " " + _vm._s(_vm.selectedAttributes.length) + " selected "
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        return _vm.addAllAttributes()
                      },
                    },
                  },
                  [
                    _vm.selectedAttributes.length !== _vm.attributes.length
                      ? _c("span", [_vm._v("Add")])
                      : _c("span", [_vm._v("Remove")]),
                    _vm._v(" All (" + _vm._s(_vm.attributes.length) + ") "),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.attributes.length
            ? _c("div", { staticClass: "select-header" }, [
                _c("span", [
                  _vm._v(" Distinct Values "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content:
                              "For selected product type(s), source(s) and 1 year test period, the number of distinct values of this attribute",
                          },
                          expression:
                            "{\n              content: 'For selected product type(s), source(s) and 1 year test period, the number of distinct values of this attribute'\n            }",
                        },
                      ],
                      staticClass: "info-icon",
                    },
                    [
                      _c("i", { staticClass: "material-icons info-outline" }, [
                        _vm._v("info_outline"),
                      ]),
                      _c("i", { staticClass: "material-icons info" }, [
                        _vm._v("info"),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "select-scrollable" }, [
            _c(
              "div",
              {
                staticClass: "select-inner",
                class: { "select-inner--empty": !_vm.attributes.length },
              },
              [
                !_vm.attributes.length
                  ? _c("div", { staticClass: "select-all-empty" }, [
                      _c("span", { staticClass: "icon-layout-3" }),
                      !_vm.selectedProducts.length
                        ? _c("p", [
                            _vm._v(
                              " Select a Product to begin building a Profile "
                            ),
                          ])
                        : _c("p", [
                            _vm._v(
                              " Select Data Sources to see available product attributes "
                            ),
                          ]),
                    ])
                  : _vm._e(),
                _vm._l(_vm.attributes, function (attr, index) {
                  return _c(
                    "div",
                    {
                      key: "ds_" + index,
                      staticClass: "select-item select-item--with-count",
                      class: {
                        "select-item--active":
                          _vm.selectedAttributes.indexOf(attr.id) > -1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectAttributesItem(attr.id)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "select-item__left",
                          attrs: { title: attr.display },
                        },
                        [
                          _c("div", { staticClass: "select-item__checkbox" }),
                          _vm._v(" " + _vm._s(attr.display) + " "),
                          attr.fixed_order
                            ? _c(
                                "div",
                                {
                                  staticClass: "select-item__bucketing",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.selectBucketing(attr.id)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("edit"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.returnSelectedBucketingString(
                                          attr.id
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm.attrValues &&
                      !_vm.attrValueQueryActive &&
                      !_vm.showDevAttrCount
                        ? _c("div", { staticClass: "select-item__count" }, [
                            _vm._v(" " + _vm._s(_vm.attrValues[attr.id]) + " "),
                          ])
                        : _vm._e(),
                      _vm.showDevAttrCount
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "select-item__count select-item__count--dev",
                            },
                            [_vm._v(" " + _vm._s(attr.count) + " ")]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }